import { useEffect, useState } from 'react';

import { AppState } from '../../../state/store';
import { getVehicleDetailsWithImageRequest } from './request';

type DetailState = {
  registration: string;
  history: {
    push: Function;
  };
};

const vehicleNotFound = '/vehicle-not-found';

export const useGetVehicleDetailsWithImage = (addVehicleDetails: Function) => {
  const [details, setDetails] = useState<DetailState | null>(null);

  useEffect(() => {
    if (details && details?.registration && details.history) {
      getVehicleDetailsWithImageRequest(details?.registration)
        .then((response) => {
          if (
            response.data?.requestResultsType?.asset.supplementaryAssetData.cap
              .vehicleType !== 'C' ||
            response.data?.requestResultsType?.asset.primaryAssetData.dvla.make
              .description === 'JAGUAR' ||
            response.data?.requestResultsType.asset.primaryAssetData.dvla.make
              .description === 'LAND ROVER' ||
            response.data?.requestResultsType.asset.primaryAssetData.dvla.make
              .description === 'VOLVO'
          ) {
            details.history.push(`${vehicleNotFound}`);
          } else if (
            (!response.data?.requestResultsType?.asset.supplementaryAssetData
              .cap.capId &&
              !response.data?.requestResultsType?.asset.supplementaryAssetData
                .cap.capCode) ||
            !response.data?.requestResultsType?.asset.primaryAssetData.dvla
              .keyDates.firstRegistered.date
          ) {
            details.history.push(`${vehicleNotFound}`);
          } else {
            addVehicleDetails(response.data);
          }
        })
        .catch(() => {
          if (details.history && details.history.push) {
            details.history.push(`${vehicleNotFound}`);
          }
        });
    }

    // eslint-disable-next-line
  }, [details]);

  return ({ registration, groupId }: AppState, history: any) => {
    setDetails({ registration, history });
  };
};
